import { Address } from 'types/Address';

export const formatClinicAddress = (clinicAddress: Address) => {
  if (!clinicAddress) {
    return '';
  }

  return `
  ${clinicAddress.street_number}
  ${clinicAddress.route}, ${clinicAddress.locality}
  ${clinicAddress.administrative_area_level_1_short}
  ${clinicAddress.postal_code}
  `;
};
